import React, { useState, useEffect, useCallback } from "react";
import { supabase } from "./supabaseClient";

const G = "#1a6b3c";

const UR = {
  appTitle:"سہولت انتظام پورٹل", newIssue:"نئی خرابی رپورٹ کریں",
  myIssues:"میری رپورٹس", inspection:"معائنہ کریں",
  submit:"جمع کریں", signOut:"خروج",
  stOpen:"کھلا", stInProg:"کام جاری", stResolved:"حل ہو گیا",
  priLow:"معمولی", priMedium:"اہم", priHigh:"بہت اہم", priCritical:"فوری توجہ",
  catPaint:"رنگ و پینٹ", catElec:"بجلی", catPlumb:"پانی و پلمبنگ",
  catClean:"صفائی", catRes:"کلاس وسائل", catSafety:"حفاظت", catOther:"دیگر",
  locClass:"کلاس روم", locToilet:"ٹوائلٹ", locOffice:"دفتر",
  locCorridor:"راہداری", locGround:"گراؤنڈ", locOutside:"باہری علاقہ", locOther:"دیگر",
  lblTitle:"مسئلہ کیا ہے؟", lblLoc:"کہاں ہے؟", lblCat:"قسم",
  lblPri:"اہمیت", lblDesc:"تفصیل (اختیاری)",
  noIssues:"ابھی تک کوئی رپورٹ نہیں", noInspect:"فی الحال کوئی معائنہ نہیں",
  adminReply:"منتظم کا جواب",
  inspOk:"ٹھیک ہے ✓", inspAtt:"توجہ درکار", inspCrit:"فوری ضروری",
  inspNotes:"نوٹ (اختیاری)", inspComplete:"معائنہ مکمل کریں",
  openIssues:"کھلے مسائل", pending:"باقی معائنے",
};

const CATS = [
  {en:"painting",  ur:UR.catPaint,  icon:"🎨"},
  {en:"electrical",ur:UR.catElec,   icon:"⚡"},
  {en:"plumbing",  ur:UR.catPlumb,  icon:"🚰"},
  {en:"cleaning",  ur:UR.catClean,  icon:"🧹"},
  {en:"resources", ur:UR.catRes,    icon:"📚"},
  {en:"safety",    ur:UR.catSafety, icon:"⚠️"},
  {en:"other",     ur:UR.catOther,  icon:"🔧"},
];
const PRIS = [
  {en:"low",     ur:UR.priLow,      color:"#6b7280",bg:"#f3f4f6"},
  {en:"medium",  ur:UR.priMedium,   color:"#d97706",bg:"#fffbeb"},
  {en:"high",    ur:UR.priHigh,     color:"#ea580c",bg:"#fff7ed"},
  {en:"critical",ur:UR.priCritical, color:"#e11d48",bg:"#fff0f3"},
];
const LOCS = [
  {en:"classroom", ur:UR.locClass},   {en:"toilet",  ur:UR.locToilet},
  {en:"office",    ur:UR.locOffice},  {en:"corridor",ur:UR.locCorridor},
  {en:"ground",    ur:UR.locGround},  {en:"outside", ur:UR.locOutside},
  {en:"other",     ur:UR.locOther},
];
const STATUS_META = {
  open:       {ur:UR.stOpen,    color:"#2563eb",bg:"#eff6ff"},
  in_progress:{ur:UR.stInProg,  color:"#d97706",bg:"#fffbeb"},
  resolved:   {ur:UR.stResolved,color:"#16a34a",bg:"#dcfce7"},
};
const RINST = [
  {en:"ok",       ur:UR.inspOk,   color:"#16a34a",bg:"#dcfce7"},
  {en:"attention",ur:UR.inspAtt,  color:"#d97706",bg:"#fffbeb"},
  {en:"critical", ur:UR.inspCrit, color:"#e11d48",bg:"#fff0f3"},
];

const fmFont = "'Noto Nastaliq Urdu','Segoe UI','Arial Unicode MS',sans-serif";

const DEFAULT_TEMPLATES = [
  {
    title:"Masjid Inspection",
    title_ur:"مسجد معائنہ",
    items:[
      {label:"Masjid paint condition checked",                  label_ur:"مسجد کی پینٹ کا معائنہ کیا",          area:"Masjid"},
      {label:"Wudu area clean and water flowing",               label_ur:"وضو خانہ صاف اور پانی بہہ رہا ہے",   area:"Masjid"},
      {label:"Prayer carpets clean and properly arranged",      label_ur:"نمازی قالین صاف اور ترتیب سے بچھے",  area:"Masjid"},
      {label:"Ceiling fans / AC working",                       label_ur:"پنکھے اور اے سی کام کر رہے ہیں",    area:"Masjid"},
      {label:"All lights and tube lights working",              label_ur:"تمام بلب اور ٹیوب لائٹس ٹھیک ہیں",  area:"Masjid"},
      {label:"Windows and doors opening/closing properly",      label_ur:"کھڑکیاں اور دروازے ٹھیک بند ہوتے",  area:"Masjid"},
      {label:"Masjid bathroom/toilet clean",                    label_ur:"مسجد کا بیت الخلاء صاف ہے",          area:"Masjid"},
      {label:"Masjid floor clean and mopped",                   label_ur:"مسجد کا فرش صاف اور دھلا ہوا",      area:"Masjid"},
      {label:"Shoes rack outside Masjid organized",             label_ur:"جوتے باہر ترتیب سے رکھے گئے",       area:"Masjid"},
    ],
  },
  {
    title:"Classroom & Building Inspection",
    title_ur:"کلاس روم اور عمارت معائنہ",
    items:[
      {label:"All classroom walls paint in good condition",     label_ur:"تمام کمروں کی پینٹ ٹھیک حالت میں", area:"Classrooms"},
      {label:"Blackboards/whiteboards clean and usable",        label_ur:"بلیک بورڈ اور وائٹ بورڈ صاف",       area:"Classrooms"},
      {label:"Classroom lights and fans working",               label_ur:"کلاس روم میں بجلی اور پنکھے ٹھیک",  area:"Classrooms"},
      {label:"Desks and chairs in good condition (no broken)",  label_ur:"میزیں اور کرسیاں ٹھیک — کوئی ٹوٹی نہیں",area:"Classrooms"},
      {label:"Classroom windows and doors functioning",         label_ur:"کلاس کی کھڑکیاں اور دروازے ٹھیک",  area:"Classrooms"},
      {label:"Corridors and pathways clean and clear",          label_ur:"راہداریاں صاف اور رکاوٹ سے پاک",    area:"Building"},
      {label:"Stairs handrails secure and safe",                label_ur:"سیڑھیوں کی ریلنگ مضبوط اور محفوظ",  area:"Building"},
      {label:"Office/reception area tidy",                      label_ur:"دفتر اور استقبالیہ ترتیب سے",        area:"Building"},
      {label:"Roof/terrace: no water pooling or cracks",        label_ur:"چھت پر پانی جمع یا درار نہیں",       area:"Building"},
      {label:"Rooms needing paint touch-up identified",         label_ur:"پینٹ کی ضرورت والے کمرے نوٹ کیے",   area:"Maintenance"},
    ],
  },
  {
    title:"Electrical & Utilities Check",
    title_ur:"بجلی اور یوٹیلیٹی چیک",
    items:[
      {label:"Main switchboard safe (no exposed wires)",        label_ur:"مین بورڈ محفوظ — کوئی تار ننگا نہیں",area:"Electrical"},
      {label:"Generator functional and fuel level adequate",    label_ur:"جنریٹر ٹھیک اور تیل کافی ہے",       area:"Electrical"},
      {label:"Water pump working properly",                     label_ur:"واٹر پمپ ٹھیک کام کر رہا ہے",       area:"Utilities"},
      {label:"Water supply available in all areas",             label_ur:"تمام جگہوں پر پانی موجود ہے",       area:"Utilities"},
      {label:"No broken or hanging light fixtures",             label_ur:"کوئی ٹوٹا ہوا بلب یا فٹنگ نہیں",   area:"Electrical"},
      {label:"Extension cords safely managed",                  label_ur:"تار محفوظ طریقے سے لگے ہیں",        area:"Electrical"},
      {label:"Inverter/UPS battery checked",                    label_ur:"انورٹر اور یو پی ایس بیٹری چیک کی", area:"Electrical"},
    ],
  },
  {
    title:"Hygiene & Cleaning Check",
    title_ur:"صفائی اور حفظان صحت",
    items:[
      {label:"Student toilets cleaned (morning check)",         label_ur:"طلباء کے بیت الخلاء صبح صاف کیے",  area:"Hygiene"},
      {label:"Staff toilets cleaned",                           label_ur:"اسٹاف بیت الخلاء صاف ہے",          area:"Hygiene"},
      {label:"Drinking water available (cooler/tank)",          label_ur:"پینے کا پانی موجود ہے",             area:"Hygiene"},
      {label:"All waste bins emptied",                          label_ur:"تمام کوڑے دان خالی کر دیے گئے",    area:"Cleaning"},
      {label:"School grounds swept and litter-free",            label_ur:"گراؤنڈ صاف اور کوڑا نہیں",         area:"Cleaning"},
      {label:"Drains clear — no blockage or bad smell",         label_ur:"نالیاں صاف اور بند نہیں ہیں",      area:"Hygiene"},
      {label:"Kitchen/canteen area clean",                      label_ur:"کینٹین اور کچن صاف ہے",             area:"Hygiene"},
    ],
  },
  {
    title:"Weekly Safety & Maintenance",
    title_ur:"ہفتہ وار حفاظت و دیکھ بھال",
    items:[
      {label:"Boundary wall/fence intact and secure",           label_ur:"باؤنڈری وال محفوظ اور سلامت ہے",  area:"Safety"},
      {label:"Main gate functioning properly",                  label_ur:"مین گیٹ ٹھیک کام کر رہا ہے",      area:"Safety"},
      {label:"Security/outdoor lights working",                 label_ur:"سیکیورٹی لائٹس کام کر رہی ہیں",   area:"Safety"},
      {label:"Fire extinguisher accessible and not expired",    label_ur:"آگ بجھانے والا آلہ دستیاب ہے",     area:"Safety"},
      {label:"First aid kit stocked and accessible",            label_ur:"فرسٹ ایڈ کٹ موجود اور مکمل ہے",   area:"Safety"},
      {label:"Rooms with paint damage noted for repair",        label_ur:"پینٹ نقصان والے کمرے نوٹ کیے",    area:"Maintenance"},
      {label:"Garden/plants watered and maintained",            label_ur:"باغ اور پودے پانی دیا اور دیکھ بھال",area:"Grounds"},
      {label:"Parking area safe and organized",                 label_ur:"پارکنگ محفوظ اور ترتیب سے ہے",    area:"Grounds"},
    ],
  },
];

// ── Small helpers ─────────────────────────────────────────────────────────
function FMCard({children}){
  return <div style={{background:"white",borderRadius:14,padding:16,boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>{children}</div>;
}
function FMLabel({children}){
  return <label style={{fontSize:13,fontWeight:700,color:"#374151",display:"block",marginBottom:8,fontFamily:fmFont}}>{children}</label>;
}
function FMSelBtn({active,onClick,priColor,priBg,children,style:extra={}}){
  return (
    <button onClick={onClick}
      style={{padding:"10px 8px",borderRadius:9,
        border:`1.5px solid ${active?(priColor||G):"#d1d5db"}`,
        background:active?(priBg||"#f0fdf7"):"white",
        color:active?(priColor||G):"#374151",
        fontWeight:active?800:500,fontSize:13,cursor:"pointer",
        fontFamily:fmFont,display:"flex",alignItems:"center",
        justifyContent:"center",gap:4,...extra}}>
      {children}
    </button>
  );
}

// ── Facility Manager Portal (Urdu UI) ─────────────────────────────────────
export function FacilityManagerPortal({onSignOut}){
  const [view,       setView]      = useState("home");
  const [issues,     setIssues]    = useState([]);
  const [adminTasks, setAdminTasks]= useState([]);
  const [rounds,     setRounds]    = useState([]);
  const [submitting, setSubmitting]= useState(false);
  const [toast,      setToast]     = useState(null);
  const [selRound,   setSelRound]  = useState(null);
  const [selTask,    setSelTask]   = useState(null);
  const [roundItems, setRoundItems]= useState([]);
  const [responses,  setResponses] = useState({});
  const [form, setForm] = useState({
    title:"", location:"classroom", category:"other", priority:"medium", description:""
  });

  const notify = (msg,ok=true)=>{ setToast({msg,ok}); setTimeout(()=>setToast(null),3200); };

  const daysLeft = (deadline) => deadline ? Math.ceil((new Date(deadline)-new Date())/(1000*60*60*24)) : null;

  const load = useCallback(async()=>{
    const [iRes,rRes] = await Promise.all([
      supabase.from("facility_issues").select("*").order("reported_at",{ascending:false}),
      supabase.from("inspection_rounds")
        .select("*, inspection_templates(title,title_ur)")
        .eq("status","pending").order("due_date",{ascending:true}),
    ]);
    const all = iRes.data||[];
    setAdminTasks(all.filter(i=>i.assigned_to_fm&&i.status!=="resolved"));
    setIssues(all.filter(i=>!i.assigned_to_fm));
    setRounds(rRes.data||[]);
  },[]);

  useEffect(()=>{ load(); },[load]);

  const submitIssue = async()=>{
    if(!form.title.trim()) return;
    setSubmitting(true);
    const {error} = await supabase.from("facility_issues").insert({
      title:form.title, location:form.location, category:form.category,
      priority:form.priority, description:form.description, status:"open",
    });
    setSubmitting(false);
    if(error){ notify("خرابی آئی، دوبارہ کوشش کریں",false); return; }
    notify("رپورٹ کامیابی سے جمع ہو گئی ✓");
    setForm({title:"",location:"classroom",category:"other",priority:"medium",description:""});
    load(); setView("home");
  };

  const startRound = async(round)=>{
    setSelRound(round);
    const {data} = await supabase.from("inspection_items")
      .select("*").eq("template_id",round.template_id).order("sort_order");
    const items = data||[];
    setRoundItems(items);
    const init={};
    items.forEach(it=>{ init[it.id]={result:"ok",notes:""}; });
    setResponses(init);
    setView("do_round");
  };

  const completeRound = async()=>{
    if(!selRound) return;
    const missing = roundItems.filter(it=>{
      const r=responses[it.id]?.result||"ok";
      const n=(responses[it.id]?.notes||"").trim();
      return (r==="attention"||r==="critical") && !n;
    });
    if(missing.length>0){
      notify(`${missing.length} توجہ/خطرناک چیزوں میں نوٹ لازمی ہے ⚠️`,false);
      return;
    }
    setSubmitting(true);
    const rows = roundItems.map(it=>({
      round_id:selRound.id, item_id:it.id,
      item_label:it.label_ur||it.label,
      result:responses[it.id]?.result||"ok",
      notes:responses[it.id]?.notes||"",
    }));
    await Promise.all([
      supabase.from("inspection_responses").insert(rows),
      supabase.from("inspection_rounds").update({
        status:"completed", completed_at:new Date().toISOString()
      }).eq("id",selRound.id),
    ]);
    setSubmitting(false);
    notify("معائنہ کامیابی سے مکمل ہو گیا ✓");
    load(); setView("home");
  };

  const openCount = issues.filter(i=>i.status==="open"||i.status==="in_progress").length;
  const overdueCount = adminTasks.filter(t=>t.deadline&&daysLeft(t.deadline)<0).length;
  const urgentTasks = adminTasks.filter(t=>{ const dl=daysLeft(t.deadline); return dl!==null&&dl>=0&&dl<=3; });
  const PRI_ORDER = {critical:0,high:1,medium:2,low:3};
  const sortedTasks = [...adminTasks].sort((a,b)=>{
    const pa=PRI_ORDER[a.priority]??2, pb=PRI_ORDER[b.priority]??2;
    if(pa!==pb) return pa-pb;
    const da=daysLeft(a.deadline)??999, db=daysLeft(b.deadline)??999;
    return da-db;
  });
  const wrap = {minHeight:"100vh",background:"#f0fdf4",fontFamily:fmFont,direction:"rtl"};

  const Header = ()=>(
    <div style={{background:`linear-gradient(135deg,#0d3d1f,${G})`,color:"white",
      padding:"14px 18px",display:"flex",justifyContent:"space-between",
      alignItems:"center",boxShadow:"0 2px 12px rgba(0,0,0,.2)"}}>
      <div>
        <div style={{fontWeight:800,fontSize:18}}>{UR.appTitle}</div>
        <div style={{fontSize:11,opacity:.75,marginTop:2}}>QK Academy</div>
      </div>
      <button onClick={onSignOut}
        style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:9,
          padding:"7px 14px",color:"white",fontWeight:700,fontSize:12,cursor:"pointer"}}>
        {UR.signOut}
      </button>
    </div>
  );

  const Toast = ()=> toast ? (
    <div style={{position:"fixed",bottom:20,right:20,left:20,zIndex:9999,
      background:toast.ok?"#dcfce7":"#fee2e2",
      color:toast.ok?"#16a34a":"#e11d48",borderRadius:12,
      padding:"12px 18px",fontWeight:700,fontSize:14,
      boxShadow:"0 4px 16px rgba(0,0,0,.15)",textAlign:"center",fontFamily:fmFont}}>
      {toast.msg}
    </div>
  ) : null;

  /* ── HOME DASHBOARD ── */
  if(view==="home") return (
    <div style={wrap}><Header/><Toast/>
      <div style={{padding:16,display:"flex",flexDirection:"column",gap:14}}>

        {/* Alert banner if overdue */}
        {overdueCount>0&&(
          <div style={{background:"#fef2f2",border:"2px solid #fca5a5",borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:22}}>🚨</span>
            <div style={{flex:1}}>
              <div style={{fontWeight:900,color:"#dc2626",fontSize:14,fontFamily:fmFont}}>{overdueCount} کام کی آخری تاریخ گزر چکی ہے!</div>
              <div style={{fontSize:11,color:"#9ca3af",marginTop:2,fontFamily:fmFont}}>فوری توجہ درکار ہے</div>
            </div>
          </div>
        )}
        {urgentTasks.length>0&&overdueCount===0&&(
          <div style={{background:"#fffbeb",border:"2px solid #fde68a",borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:22}}>⚠️</span>
            <div style={{fontWeight:800,color:"#d97706",fontSize:13,fontFamily:fmFont}}>{urgentTasks.length} کام ۳ دن میں ختم ہونے والے ہیں</div>
          </div>
        )}

        {/* Stats — 2×2 grid */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {[
            {val:adminTasks.length,  label:"تفویض کام",   color:"#1a6b3c", bg:"#dcfce7", icon:"📌", border:"#86efac"},
            {val:rounds.length,      label:"باقی معائنے", color:"#7c3aed", bg:"#f5f3ff", icon:"🔍", border:"#c4b5fd"},
            {val:overdueCount,       label:"وقت گزرا",    color:"#dc2626", bg:"#fef2f2", icon:"⏰", border:"#fca5a5"},
            {val:openCount,          label:"کھلے مسائل",  color:"#d97706", bg:"#fffbeb", icon:"📝", border:"#fde68a"},
          ].map(s=>(
            <div key={s.label} style={{background:s.bg,borderRadius:14,padding:"16px 12px",textAlign:"center",border:`2px solid ${s.border}`,boxShadow:"0 2px 6px rgba(0,0,0,.04)"}}>
              <div style={{fontSize:24,lineHeight:1}}>{s.icon}</div>
              <div style={{fontSize:34,fontWeight:900,color:s.color,lineHeight:1.1,marginTop:4}}>{s.val}</div>
              <div style={{fontSize:11,color:"#6b7280",marginTop:4,fontFamily:fmFont}}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Admin-assigned tasks — sorted by priority */}
        {sortedTasks.length>0&&(
          <div style={{background:"white",borderRadius:14,padding:"16px",boxShadow:"0 2px 10px rgba(0,0,0,.07)",border:"2px solid #fde68a"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontWeight:900,fontSize:15,color:"#92400e",fontFamily:fmFont}}>📌 تفویض کردہ کام</div>
              <div style={{fontSize:11,color:"#9ca3af",fontFamily:fmFont}}>{sortedTasks.length} کام</div>
            </div>
            {sortedTasks.map(task=>{
              const dl=daysLeft(task.deadline);
              const overdue=dl!==null&&dl<0;
              const urgent=dl!==null&&dl>=0&&dl<=3;
              const pri=PRIS.find(p=>p.en===task.priority)||PRIS[1];
              const barPct=dl===null?0:overdue?100:Math.max(5,100-Math.round(dl/14*100));
              return (
                <div key={task.id} onClick={()=>{setSelTask(task);setView("task_detail");}}
                  style={{padding:"12px 14px",borderRadius:10,marginBottom:8,cursor:"pointer",
                    border:`2px solid ${overdue?"#fca5a5":urgent?"#fde68a":task.priority==="high"||task.priority==="critical"?"#fed7aa":"#e5e7eb"}`,
                    background:overdue?"#fef2f2":urgent?"#fffbeb":"white",
                    transition:"box-shadow .15s",boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:6}}>
                    <div style={{fontWeight:700,fontSize:14,color:"#111827",fontFamily:fmFont,flex:1}}>{task.title}</div>
                    <span style={{background:pri.bg,color:pri.color,borderRadius:6,padding:"2px 9px",fontSize:10,fontWeight:800,flexShrink:0,fontFamily:fmFont,border:`1px solid ${pri.color}30`}}>{pri.ur}</span>
                  </div>
                  {/* Deadline bar */}
                  {dl!==null&&(
                    <>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:4,fontFamily:fmFont}}>
                        <span style={{color:overdue?"#dc2626":urgent?"#d97706":"#6b7280",fontWeight:700}}>
                          {overdue?`⚠️ ${Math.abs(dl)} دن گزرے`:dl===0?"🔴 آج آخری دن!":dl===1?"🟡 کل آخری دن":`🟢 ${dl} دن باقی`}
                        </span>
                        <span style={{color:"#9ca3af"}}>📅 {new Date(task.deadline).toLocaleDateString("ur-PK")}</span>
                      </div>
                      <div style={{height:7,background:"#f3f4f6",borderRadius:4,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${barPct}%`,borderRadius:4,transition:"width .5s",
                          background:overdue?"#dc2626":urgent?"#f59e0b":"#22c55e"}}/>
                      </div>
                    </>
                  )}
                  {task.admin_notes&&<div style={{fontSize:11,color:"#6b7280",marginTop:6,fontFamily:fmFont,direction:"rtl",background:"#f9fafb",borderRadius:6,padding:"5px 8px"}}>💬 {task.admin_notes}</div>}
                  <div style={{marginTop:6,fontSize:10,color:"#9ca3af",fontFamily:fmFont,textAlign:"left",direction:"ltr"}}>→ tap to update status</div>
                </div>
              );
            })}
          </div>
        )}

        {adminTasks.length===0&&(
          <div style={{background:"white",borderRadius:14,padding:"28px 16px",textAlign:"center",border:"1.5px solid #e5e7eb",boxShadow:"0 1px 4px rgba(0,0,0,.04)"}}>
            <div style={{fontSize:36,marginBottom:8}}>✅</div>
            <div style={{fontWeight:800,color:"#16a34a",fontSize:15,fontFamily:fmFont}}>کوئی تفویض کردہ کام نہیں</div>
            <div style={{fontSize:12,color:"#9ca3af",marginTop:4,fontFamily:fmFont}}>سب کام مکمل ہیں</div>
          </div>
        )}

        {/* Pending inspection rounds */}
        {rounds.length>0&&(
          <div style={{background:"white",borderRadius:14,padding:"16px",boxShadow:"0 2px 10px rgba(0,0,0,.07)",border:"1.5px solid #e0d7ff"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontWeight:900,fontSize:15,color:"#4c1d95",fontFamily:fmFont}}>🔍 باقی معائنے</div>
              <div style={{fontSize:11,color:"#9ca3af",fontFamily:fmFont}}>{rounds.length} باقی</div>
            </div>
            {rounds.map(round=>{
              const dl=daysLeft(round.due_date);
              const overdue=dl!==null&&dl<0;
              return (
                <div key={round.id} style={{padding:"12px 14px",borderRadius:10,marginBottom:8,
                  border:`1.5px solid ${overdue?"#fca5a5":"#e0d7ff"}`,background:overdue?"#fef2f2":"#faf5ff",
                  boxShadow:"0 1px 3px rgba(0,0,0,.03)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:700,fontSize:14,color:"#4c1d95",fontFamily:fmFont}}>{round.inspection_templates?.title_ur||round.inspection_templates?.title||"معائنہ"}</div>
                      {dl!==null&&(
                        <div style={{fontSize:11,color:overdue?"#dc2626":dl<=2?"#d97706":"#6b7280",marginTop:2,fontFamily:fmFont}}>
                          📅 {new Date(round.due_date+"T12:00:00").toLocaleDateString("ur-PK")} &nbsp;·&nbsp;
                          {overdue?`${Math.abs(dl)} دن گزرے`:dl===0?"آج آخری دن":dl===1?"کل آخری دن":`${dl} دن باقی`}
                        </div>
                      )}
                    </div>
                    <button onClick={()=>startRound(round)}
                      style={{background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",
                        borderRadius:9,padding:"10px 18px",fontWeight:800,fontSize:14,cursor:"pointer",
                        fontFamily:fmFont,flexShrink:0}}>▶ شروع کریں</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Quick actions */}
        <div style={{fontWeight:800,fontSize:13,color:"#374151",fontFamily:fmFont,marginBottom:-6}}>فوری اقدام</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <button onClick={()=>setView("new_issue")}
            style={{background:`linear-gradient(135deg,#0d3d1f,${G})`,color:"white",border:"none",
              borderRadius:14,padding:"18px 10px",fontSize:14,fontWeight:800,cursor:"pointer",
              boxShadow:"0 4px 14px rgba(26,107,60,.3)",display:"flex",flexDirection:"column",alignItems:"center",
              justifyContent:"center",gap:5,fontFamily:fmFont}}>
            <span style={{fontSize:26}}>📋</span>{UR.newIssue}
          </button>
          <button onClick={()=>setView("my_issues")}
            style={{background:"white",color:"#1d4ed8",border:"2px solid #bfdbfe",borderRadius:14,
              padding:"18px 10px",fontSize:14,fontWeight:800,cursor:"pointer",
              boxShadow:"0 2px 8px rgba(0,0,0,.05)",
              display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:5,fontFamily:fmFont}}>
            <span style={{fontSize:26}}>📝</span>{UR.myIssues}
          </button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr",gap:10}}>
          {rounds.length>0&&(
            <button onClick={()=>startRound(rounds[0])}
              style={{background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",
                borderRadius:14,padding:"16px 12px",fontSize:14,fontWeight:800,cursor:"pointer",
                boxShadow:"0 4px 14px rgba(124,58,237,.3)",display:"flex",alignItems:"center",
                justifyContent:"center",gap:8,fontFamily:fmFont}}>
              <span style={{fontSize:22}}>🔍</span>اگلا معائنہ شروع کریں{rounds.length>1?` (${rounds.length} باقی)`:""}
            </button>
          )}
        </div>

      </div>
    </div>
  );

  /* ── TASK DETAIL ── */
  if(view==="task_detail"&&selTask) return (
    <div style={wrap}><Header/><Toast/>
      <div style={{padding:16,display:"flex",flexDirection:"column",gap:12}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <button onClick={()=>setView("home")} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",padding:4}}>←</button>
          <div style={{fontSize:17,fontWeight:900,color:"#111827",fontFamily:fmFont}}>تفویض کردہ کام</div>
        </div>

        {/* Task card */}
        <div style={{background:"white",borderRadius:14,padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,.06)",border:"2px solid #fde68a"}}>
          <div style={{fontWeight:900,fontSize:16,color:"#111827",marginBottom:8,fontFamily:fmFont,direction:"rtl"}}>{selTask.title}</div>
          {selTask.description&&(
            <div style={{fontSize:13,color:"#374151",marginBottom:12,fontFamily:fmFont,direction:"rtl",lineHeight:1.8,background:"#fffbeb",borderRadius:8,padding:"10px 12px"}}>
              {selTask.description}
            </div>
          )}
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
            {(()=>{const pri=PRIS.find(p=>p.en===selTask.priority)||PRIS[1]; return <span style={{background:pri.bg,color:pri.color,borderRadius:7,padding:"3px 10px",fontSize:12,fontWeight:700,fontFamily:fmFont}}>{pri.ur}</span>;})()}
            <span style={{background:"#f3f4f6",color:"#374151",borderRadius:7,padding:"3px 10px",fontSize:12,fontFamily:fmFont}}>{LOCS.find(l=>l.en===selTask.location)?.ur||selTask.location}</span>
            {(()=>{const cat=CATS.find(c=>c.en===selTask.category)||CATS[6]; return <span style={{background:"#f3f4f6",color:"#374151",borderRadius:7,padding:"3px 10px",fontSize:12}}>{cat.icon} {cat.ur}</span>;})()}
          </div>
          {/* Deadline progress */}
          {selTask.deadline&&(()=>{
            const dl=daysLeft(selTask.deadline);
            const overdue=dl<0;
            const reported=new Date(selTask.reported_at||new Date());
            const deadline=new Date(selTask.deadline);
            const totalDays=Math.max(1,Math.round((deadline-reported)/(1000*60*60*24)));
            const elapsed=Math.min(totalDays,Math.round((new Date()-reported)/(1000*60*60*24)));
            const pct=Math.min(100,Math.round(elapsed/totalDays*100));
            return (
              <div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:5,fontFamily:fmFont}}>
                  <span style={{color:overdue?"#dc2626":dl<=3?"#d97706":"#6b7280",fontWeight:700}}>
                    {overdue?`${Math.abs(dl)} دن گزر گئے ⚠️`:dl===0?"آج آخری دن!":dl===1?"کل آخری دن":`${dl} دن باقی`}
                  </span>
                  <span style={{color:"#9ca3af"}}>آخری تاریخ: {deadline.toLocaleDateString("ur-PK")}</span>
                </div>
                <div style={{height:10,background:"#f3f4f6",borderRadius:5,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${pct}%`,borderRadius:5,transition:"width .5s",
                    background:overdue?"#dc2626":pct>80?"#f59e0b":"#22c55e"}}/>
                </div>
              </div>
            );
          })()}
          {selTask.admin_notes&&(
            <div style={{background:"#f0fdf7",borderRadius:10,padding:"10px 12px",marginTop:12,border:`1px solid ${G}30`}}>
              <div style={{fontSize:11,fontWeight:700,color:G,marginBottom:2,fontFamily:fmFont}}>💬 ایڈمن کا پیغام:</div>
              <div style={{fontSize:13,color:"#374151",fontFamily:fmFont,direction:"rtl",lineHeight:1.6}}>{selTask.admin_notes}</div>
            </div>
          )}
        </div>

        {/* Status update */}
        <div style={{background:"white",borderRadius:14,padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
          <div style={{fontWeight:800,fontSize:14,color:"#111827",marginBottom:12,fontFamily:fmFont}}>صورتحال اپ ڈیٹ کریں</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <button onClick={async()=>{
              setSubmitting(true);
              await supabase.from("facility_issues").update({status:"in_progress"}).eq("id",selTask.id);
              setSubmitting(false); notify("کام جاری ہے کے طور پر نشان زد ✓");
              load(); setView("home");
            }} disabled={submitting||selTask.status==="in_progress"}
              style={{padding:"14px",borderRadius:10,border:`2px solid ${selTask.status==="in_progress"?"#d97706":"#fde68a"}`,
                background:selTask.status==="in_progress"?"#fef3c7":"white",
                color:"#d97706",fontWeight:800,fontSize:14,cursor:selTask.status==="in_progress"?"default":"pointer",fontFamily:fmFont}}>
              🔄 کام جاری ہے
            </button>
            <button onClick={async()=>{
              setSubmitting(true);
              await supabase.from("facility_issues").update({status:"resolved",resolved_at:new Date().toISOString()}).eq("id",selTask.id);
              setSubmitting(false); notify("کام مکمل ہو گیا ✓");
              load(); setView("home");
            }} disabled={submitting}
              style={{padding:"14px",borderRadius:10,border:"2px solid #16a34a",background:"white",
                color:"#16a34a",fontWeight:800,fontSize:14,cursor:"pointer",fontFamily:fmFont}}>
              ✅ کام مکمل
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  /* ── NEW ISSUE ── */
  if(view==="new_issue") return (
    <div style={wrap}><Header/><Toast/>
      <div style={{padding:16,display:"flex",flexDirection:"column",gap:12}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
          <button onClick={()=>setView("home")} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",padding:4}}>←</button>
          <div style={{fontSize:18,fontWeight:800,color:"#111827"}}>{UR.newIssue}</div>
        </div>

        <FMCard>
          <FMLabel>{UR.lblTitle}</FMLabel>
          <textarea value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} rows={2}
            placeholder="مثال: کمرہ نمبر ۳ میں پینٹ اتر رہی ہے"
            style={{width:"100%",border:"1.5px solid #d1d5db",borderRadius:9,padding:"10px 12px",
              fontSize:15,fontFamily:fmFont,resize:"none",boxSizing:"border-box",direction:"rtl"}}/>
        </FMCard>

        <FMCard>
          <FMLabel>{UR.lblLoc}</FMLabel>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7}}>
            {LOCS.map(l=>(
              <FMSelBtn key={l.en} active={form.location===l.en} onClick={()=>setForm(f=>({...f,location:l.en}))}>
                {l.ur}
              </FMSelBtn>
            ))}
          </div>
        </FMCard>

        <FMCard>
          <FMLabel>{UR.lblCat}</FMLabel>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7}}>
            {CATS.map(c=>(
              <FMSelBtn key={c.en} active={form.category===c.en} onClick={()=>setForm(f=>({...f,category:c.en}))}
                style={{flexDirection:"column",padding:"10px 6px",gap:4}}>
                <span style={{fontSize:18}}>{c.icon}</span>{c.ur}
              </FMSelBtn>
            ))}
          </div>
        </FMCard>

        <FMCard>
          <FMLabel>{UR.lblPri}</FMLabel>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7}}>
            {PRIS.map(p=>(
              <FMSelBtn key={p.en} active={form.priority===p.en} onClick={()=>setForm(f=>({...f,priority:p.en}))}
                priColor={p.color} priBg={p.bg}>
                {p.ur}
              </FMSelBtn>
            ))}
          </div>
        </FMCard>

        <FMCard>
          <FMLabel>{UR.lblDesc}</FMLabel>
          <textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={3}
            placeholder="مزید تفصیل..."
            style={{width:"100%",border:"1.5px solid #d1d5db",borderRadius:9,padding:"10px 12px",
              fontSize:14,fontFamily:fmFont,resize:"none",boxSizing:"border-box",direction:"rtl"}}/>
        </FMCard>

        <button onClick={submitIssue} disabled={!form.title.trim()||submitting}
          style={{background:form.title.trim()?`linear-gradient(135deg,#0d3d1f,${G})`:"#d1d5db",
            color:"white",border:"none",borderRadius:14,padding:"16px",fontSize:16,
            fontWeight:800,cursor:form.title.trim()?"pointer":"not-allowed",fontFamily:fmFont}}>
          {submitting?"جمع ہو رہا ہے...":UR.submit}
        </button>
      </div>
    </div>
  );

  /* ── MY ISSUES ── */
  if(view==="my_issues") return (
    <div style={wrap}><Header/><Toast/>
      <div style={{padding:16,display:"flex",flexDirection:"column",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
          <button onClick={()=>setView("home")} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",padding:4}}>←</button>
          <div style={{fontSize:18,fontWeight:800,color:"#111827"}}>{UR.myIssues}</div>
        </div>
        {issues.length===0&&<div style={{textAlign:"center",color:"#9ca3af",padding:"40px 20px",fontSize:14,fontFamily:fmFont}}>{UR.noIssues}</div>}
        {issues.map(issue=>{
          const pri=PRIS.find(p=>p.en===issue.priority)||PRIS[1];
          const st=STATUS_META[issue.status]||STATUS_META.open;
          const cat=CATS.find(c=>c.en===issue.category)||CATS[6];
          return (
            <div key={issue.id} style={{background:"white",borderRadius:14,padding:"16px",
              boxShadow:"0 2px 8px rgba(0,0,0,.05)",borderRight:`4px solid ${pri.color}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:8}}>
                <div style={{fontWeight:700,fontSize:14,color:"#111827",flex:1}}>{issue.title}</div>
                <span style={{background:st.bg,color:st.color,borderRadius:8,padding:"3px 10px",fontSize:11,fontWeight:700,flexShrink:0}}>{st.ur}</span>
              </div>
              <div style={{display:"flex",gap:7,flexWrap:"wrap",marginBottom:6}}>
                <span style={{background:"#f3f4f6",borderRadius:6,padding:"2px 9px",fontSize:11,color:"#6b7280"}}>{cat.icon} {cat.ur}</span>
                <span style={{background:pri.bg,color:pri.color,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:600}}>{pri.ur}</span>
                <span style={{fontSize:11,color:"#9ca3af"}}>{LOCS.find(l=>l.en===issue.location)?.ur||issue.location}</span>
              </div>
              {issue.description&&<div style={{fontSize:12,color:"#6b7280",marginBottom:4,direction:"rtl"}}>{issue.description}</div>}
              {issue.admin_notes&&(
                <div style={{background:"#f0fdf7",borderRadius:8,padding:"8px 10px",fontSize:12,color:G,fontWeight:600}}>
                  💬 {UR.adminReply}: {issue.admin_notes}
                </div>
              )}
              <div style={{fontSize:10,color:"#d1d5db",marginTop:6}}>{new Date(issue.reported_at).toLocaleDateString("ur-PK")}</div>
            </div>
          );
        })}
      </div>
    </div>
  );

  /* ── INSPECTION LIST ── */
  if(view==="inspection") return (
    <div style={wrap}><Header/><Toast/>
      <div style={{padding:16,display:"flex",flexDirection:"column",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
          <button onClick={()=>setView("home")} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",padding:4}}>←</button>
          <div style={{fontSize:18,fontWeight:800,color:"#111827"}}>{UR.inspection}</div>
        </div>
        {rounds.length===0&&<div style={{textAlign:"center",color:"#9ca3af",padding:"40px 20px",fontSize:14,fontFamily:fmFont}}>{UR.noInspect}</div>}
        {rounds.map(round=>(
          <button key={round.id} onClick={()=>startRound(round)}
            style={{background:"white",border:"none",borderRadius:14,padding:"18px 16px",
              boxShadow:"0 2px 8px rgba(0,0,0,.08)",textAlign:"right",cursor:"pointer",
              borderRight:`4px solid #7c3aed`,width:"100%"}}>
            <div style={{fontWeight:800,fontSize:16,color:"#111827",fontFamily:fmFont}}>{round.inspection_templates?.title_ur||round.inspection_templates?.title||"معائنہ"}</div>
            {round.due_date&&<div style={{fontSize:12,color:"#6b7280",marginTop:4,fontFamily:fmFont}}>آخری تاریخ: {new Date(round.due_date).toLocaleDateString("ur-PK")}</div>}
            <div style={{marginTop:8,background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",
              borderRadius:8,padding:"6px 14px",fontSize:13,fontWeight:700,display:"inline-block",fontFamily:fmFont}}>
              شروع کریں ←
            </div>
          </button>
        ))}
      </div>
    </div>
  );

  /* ── DO A ROUND ── */
  if(view==="do_round"&&selRound) {
    const reviewedCount = roundItems.filter(it=>{
      const r=responses[it.id]?.result||"ok";
      const n=(responses[it.id]?.notes||"").trim();
      if(r==="attention"||r==="critical") return !!n;
      return true;
    }).length;
    const progressPct = roundItems.length ? Math.round(reviewedCount/roundItems.length*100) : 0;
    return (
      <div style={wrap}><Header/><Toast/>
        <div style={{padding:16,display:"flex",flexDirection:"column",gap:12}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <button onClick={()=>setView("inspection")} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",padding:4}}>←</button>
            <div style={{flex:1}}>
              <div style={{fontSize:16,fontWeight:800,color:"#111827",fontFamily:fmFont}}>{selRound.inspection_templates?.title_ur||selRound.inspection_templates?.title||"معائنہ"}</div>
              <div style={{fontSize:12,color:"#6b7280",fontFamily:fmFont}}>{reviewedCount}/{roundItems.length} مکمل</div>
            </div>
          </div>

          {/* Progress bar */}
          <div style={{background:"white",borderRadius:12,padding:"12px 14px",boxShadow:"0 1px 6px rgba(0,0,0,.05)"}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:6,fontFamily:fmFont}}>
              <span style={{color:"#374151",fontWeight:700}}>{progressPct}% مکمل</span>
              <span style={{color:"#9ca3af"}}>{roundItems.filter(it=>responses[it.id]?.result==="critical").length} خطرناک · {roundItems.filter(it=>responses[it.id]?.result==="attention").length} توجہ</span>
            </div>
            <div style={{height:8,background:"#f3f4f6",borderRadius:4,overflow:"hidden"}}>
              <div style={{height:"100%",width:`${progressPct}%`,borderRadius:4,transition:"width .4s",
                background:progressPct===100?"#22c55e":progressPct>60?"#f59e0b":"#7c3aed"}}/>
            </div>
          </div>

          {roundItems.map((item,idx)=>{
            const resp=responses[item.id]||{result:"ok",notes:""};
            const needsNote=resp.result==="attention"||resp.result==="critical";
            const missingNote=needsNote&&!(resp.notes||"").trim();
            return (
              <div key={item.id} style={{background:"white",borderRadius:14,padding:"16px",
                boxShadow:"0 2px 8px rgba(0,0,0,.05)",
                border:`1.5px solid ${missingNote?"#fca5a5":resp.result==="critical"?"#fecaca":resp.result==="attention"?"#fde68a":"#f3f4f6"}`}}>
                <div style={{fontWeight:700,fontSize:14,color:"#111827",marginBottom:10,fontFamily:fmFont}}>
                  {idx+1}. {item.label_ur||item.label}
                  {item.area&&<span style={{fontSize:11,color:"#9ca3af",fontWeight:400,marginRight:6}}>({item.area})</span>}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7,marginBottom:10}}>
                  {RINST.map(r=>(
                    <button key={r.en} onClick={()=>setResponses(p=>({...p,[item.id]:{...p[item.id],result:r.en}}))}
                      style={{padding:"10px 4px",borderRadius:9,
                        border:`1.5px solid ${resp.result===r.en?r.color:"#d1d5db"}`,
                        background:resp.result===r.en?r.bg:"white",
                        color:resp.result===r.en?r.color:"#6b7280",
                        fontWeight:resp.result===r.en?800:500,fontSize:11,
                        cursor:"pointer",fontFamily:fmFont}}>
                      {r.ur}
                    </button>
                  ))}
                </div>
                <div style={{position:"relative"}}>
                  <textarea value={resp.notes} onChange={e=>setResponses(p=>({...p,[item.id]:{...p[item.id],notes:e.target.value}}))}
                    rows={2}
                    placeholder={needsNote?"⚠️ نوٹ لازمی ہے — تفصیل لکھیں":"نوٹ (اختیاری)"}
                    style={{width:"100%",
                      border:`1.5px solid ${missingNote?"#f87171":needsNote?"#f59e0b":"#d1d5db"}`,
                      borderRadius:8,padding:"8px 10px",
                      fontSize:13,fontFamily:fmFont,resize:"none",boxSizing:"border-box",
                      direction:"rtl",background:missingNote?"#fef2f2":needsNote?"#fffbeb":"white"}}/>
                  {missingNote&&<div style={{fontSize:10,color:"#dc2626",marginTop:3,textAlign:"right",fontFamily:fmFont}}>⚠️ توجہ/خطرناک کے لیے نوٹ لازمی ہے</div>}
                </div>
              </div>
            );
          })}

          <button onClick={completeRound} disabled={submitting}
            style={{background:`linear-gradient(135deg,#0d3d1f,${G})`,color:"white",border:"none",
              borderRadius:14,padding:"16px",fontSize:16,fontWeight:800,
              cursor:"pointer",fontFamily:fmFont,marginTop:6}}>
            {submitting?"مکمل ہو رہا ہے...":UR.inspComplete+" ✓"}
          </button>
        </div>
      </div>
    );
  }

  return <div style={wrap}><Header/></div>;
}

// ── Admin / Principal Facility Inspection Dashboard ───────────────────────
export function FacilityInspectionAdmin(){
  const [sub,       setSub]      = useState("overview");
  const [issues,    setIssues]   = useState([]);
  const [templates, setTemplates]= useState([]);
  const [rounds,    setRounds]   = useState([]);
  const [loading,   setLoading]  = useState(true);
  const [toast,     setToast]    = useState(null);

  // Issues
  const [fStatus,setFStatus]=useState("all");
  const [fPri,   setFPri]  =useState("all");
  const [search, setSearch]=useState("");
  const [editNotes,  setEditNotes]  =useState({});
  const [savingNote, setSavingNote] =useState({});

  // Templates
  const [newTplEn,  setNewTplEn]  =useState("");
  const [newTplUr,  setNewTplUr]  =useState("");
  const [savingTpl, setSavingTpl] =useState(false);
  const [seedingDefaults, setSeedingDefaults] = useState(false);
  const [expanded,  setExpanded]  =useState(null);
  const [tplItems,  setTplItems]  =useState({});
  const [newItemEn, setNewItemEn] =useState("");
  const [newItemUr, setNewItemUr] =useState("");
  const [newItemArea,setNewItemArea]=useState("");
  const [savingItem,setSavingItem]=useState(false);

  // Rounds
  const [newRndTpl,  setNewRndTpl] =useState("");
  const [newRndDue,  setNewRndDue] =useState("");
  const [savingRnd,  setSavingRnd] =useState(false);
  const [viewRound,  setViewRound] =useState(null);
  const [rndResponses,setRndResponses]=useState([]);
  const [assigningWeekly, setAssigningWeekly]=useState(false);

  // Admin-assigned tasks (FM must resolve by deadline)
  const [adminTasks, setAdminTasks]=useState([]);
  const blankTask={title:"",description:"",deadline:"",priority:"medium",location:"classroom",category:"other"};
  const [newTask,  setNewTask]  =useState(blankTask);
  const [savingTask,setSavingTask]=useState(false);

  const notify=(msg,ok=true)=>{ setToast({msg,ok}); setTimeout(()=>setToast(null),3000); };

  const load=useCallback(async()=>{
    setLoading(true);
    const [iR,tR,rR,atR]=await Promise.all([
      supabase.from("facility_issues").select("*").order("reported_at",{ascending:false}),
      supabase.from("inspection_templates").select("*").order("created_at",{ascending:false}),
      supabase.from("inspection_rounds").select("*, inspection_templates(title,title_ur)").order("created_at",{ascending:false}),
      supabase.from("facility_issues").select("*").eq("assigned_to_fm",true).neq("status","resolved").order("deadline",{ascending:true}),
    ]);
    setIssues((iR.data||[]).filter(i=>!i.assigned_to_fm));
    setTemplates(tR.data||[]); setRounds(rR.data||[]);
    setAdminTasks(atR.data||[]);
    setLoading(false);
  },[]);

  useEffect(()=>{ load(); },[load]);

  const loadItems=async(tplId)=>{
    if(tplItems[tplId]) return;
    const {data}=await supabase.from("inspection_items").select("*").eq("template_id",tplId).order("sort_order");
    setTplItems(p=>({...p,[tplId]:data||[]}));
  };

  const toggleExpand=async(id)=>{
    if(expanded===id){ setExpanded(null); return; }
    setExpanded(id); await loadItems(id);
  };

  const updateStatus=async(id,status)=>{
    const upd={status,...(status==="resolved"?{resolved_at:new Date().toISOString()}:{})};
    await supabase.from("facility_issues").update(upd).eq("id",id);
    setIssues(p=>p.map(i=>i.id===id?{...i,...upd}:i));
  };

  const saveNote=async(id)=>{
    setSavingNote(p=>({...p,[id]:true}));
    await supabase.from("facility_issues").update({admin_notes:editNotes[id]||""}).eq("id",id);
    setIssues(p=>p.map(i=>i.id===id?{...i,admin_notes:editNotes[id]||""}:i));
    setSavingNote(p=>({...p,[id]:false}));
    setEditNotes(p=>{ const n={...p}; delete n[id]; return n; });
    notify("Note saved — facility manager will see it");
  };
  const [editingIssue, setEditingIssue] = useState(null);
  const [delConfirm,   setDelConfirm]   = useState(null);

  const deleteIssue=async(id)=>{
    await supabase.from("facility_issues").delete().eq("id",id);
    setIssues(p=>p.filter(i=>i.id!==id));
    setDelConfirm(null);
    notify("Issue deleted");
  };

  const saveEditIssue=async()=>{
    if(!editingIssue) return;
    const {id,...fields}=editingIssue;
    await supabase.from("facility_issues").update(fields).eq("id",id);
    setIssues(p=>p.map(i=>i.id===id?{...i,...fields}:i));
    setEditingIssue(null);
    notify("Issue updated");
  };


  const addTemplate=async()=>{
    if(!newTplEn.trim()) return;
    setSavingTpl(true);
    const {data,error}=await supabase.from("inspection_templates")
      .insert({title:newTplEn,title_ur:newTplUr||null,is_active:true})
      .select().single();
    setSavingTpl(false);
    if(error){ notify("Error: "+error.message,false); return; }
    setTemplates(p=>[data,...p]);
    setNewTplEn(""); setNewTplUr("");
    notify("Checklist template created");
  };

  const seedDefaults=async()=>{
    if(!window.confirm("Add 5 default inspection templates (Masjid, Classrooms, Electrical, Hygiene, Safety)? This will not overwrite existing templates.")) return;
    setSeedingDefaults(true);
    let count=0;
    for(const tpl of DEFAULT_TEMPLATES){
      const {data:tplData,error}=await supabase.from("inspection_templates")
        .insert({title:tpl.title,title_ur:tpl.title_ur,is_active:true})
        .select().single();
      if(error){ notify("Error: "+error.message,false); continue; }
      count++;
      const rows=tpl.items.map((it,i)=>({
        template_id:tplData.id,label:it.label,label_ur:it.label_ur,area:it.area,sort_order:i
      }));
      await supabase.from("inspection_items").insert(rows);
    }
    setSeedingDefaults(false);
    notify(count+" default templates created — ready to assign to facility manager!");
    load();
  };

  const delTemplate=async(id)=>{
    if(!window.confirm("Delete this template and all its items?")) return;
    await supabase.from("inspection_items").delete().eq("template_id",id);
    await supabase.from("inspection_templates").delete().eq("id",id);
    setTemplates(p=>p.filter(t=>t.id!==id));
    notify("Template deleted");
  };

  const addItem=async(tplId)=>{
    if(!newItemEn.trim()) return;
    setSavingItem(true);
    const existing=tplItems[tplId]||[];
    const {data,error}=await supabase.from("inspection_items").insert({
      template_id:tplId, label:newItemEn, label_ur:newItemUr||null,
      area:newItemArea||null, sort_order:existing.length,
    }).select().single();
    setSavingItem(false);
    if(error){ notify("Error: "+error.message,false); return; }
    setTplItems(p=>({...p,[tplId]:[...(p[tplId]||[]),data]}));
    setNewItemEn(""); setNewItemUr(""); setNewItemArea("");
  };

  const delItem=async(tplId,itemId)=>{
    await supabase.from("inspection_items").delete().eq("id",itemId);
    setTplItems(p=>({...p,[tplId]:(p[tplId]||[]).filter(i=>i.id!==itemId)}));
  };

  const createRound=async()=>{
    if(!newRndTpl) return;
    setSavingRnd(true);
    const tpl=templates.find(t=>t.id===newRndTpl);
    const {data,error}=await supabase.from("inspection_rounds").insert({
      template_id:newRndTpl, template_title:tpl?.title,
      due_date:newRndDue||null, status:"pending",
    }).select("*, inspection_templates(title,title_ur)").single();
    setSavingRnd(false);
    if(error){ notify("Error: "+error.message,false); return; }
    setRounds(p=>[data,...p]);
    setNewRndTpl(""); setNewRndDue("");
    notify("Round assigned — facility manager can now see it in their app");
  };

  const openRoundDetails=async(round)=>{
    setViewRound(round);
    const {data}=await supabase.from("inspection_responses").select("*").eq("round_id",round.id);
    setRndResponses(data||[]);
  };

  const assignWeeklyRounds=async()=>{
    const active=templates.filter(t=>t.is_active);
    if(active.length===0){ notify("No active templates — create checklists first",false); return; }
    setAssigningWeekly(true);
    const dueDate=new Date(); dueDate.setDate(dueDate.getDate()+7);
    const dueDateStr=dueDate.toISOString().slice(0,10);
    let created=0;
    for(const tpl of active){
      const {error}=await supabase.from("inspection_rounds").insert({
        template_id:tpl.id, template_title:tpl.title,
        due_date:dueDateStr, status:"pending",
      });
      if(!error) created++;
    }
    setAssigningWeekly(false);
    notify(`${created} round${created!==1?"s":""} assigned — due ${dueDateStr}`);
    load();
  };

  const createTask=async()=>{
    if(!newTask.title.trim()){ notify("Title is required",false); return; }
    if(!newTask.description.trim()){ notify("Description is required",false); return; }
    if(!newTask.deadline){ notify("Deadline is required",false); return; }
    setSavingTask(true);
    const {error}=await supabase.from("facility_issues").insert({
      title:newTask.title.trim(),
      description:newTask.description.trim(),
      deadline:newTask.deadline,
      priority:newTask.priority,
      location:newTask.location,
      category:newTask.category,
      assigned_to_fm:true,
      status:"open",
    });
    setSavingTask(false);
    if(error){ notify("Error: "+error.message,false); return; }
    setNewTask(blankTask);
    notify("Task assigned to Facility Manager");
    load();
  };

  const C={primary:G,pale:"#e8f5ee",border:"#d1fae5",white:"#ffffff",text:"#111827",muted:"#6b7280"};
  const filt=issues.filter(i=>{
    if(fStatus!=="all"&&i.status!==fStatus) return false;
    if(fPri!=="all"&&i.priority!==fPri) return false;
    if(search&&!i.title.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const PriTag=({v})=>{ const p=PRIS.find(x=>x.en===v)||PRIS[1]; return <span style={{background:p.bg,color:p.color,borderRadius:7,padding:"2px 8px",fontSize:11,fontWeight:700}}>{p.ur}</span>; };
  const StTag=({v})=>{ const s=STATUS_META[v]||STATUS_META.open; return <span style={{background:s.bg,color:s.color,borderRadius:7,padding:"2px 8px",fontSize:11,fontWeight:700}}>{s.ur}</span>; };

  const subTabs=[{id:"overview",label:"Overview",icon:"📊"},{id:"issues",label:"Issues",icon:"🔧"},{id:"templates",label:"Checklists",icon:"📋"},{id:"rounds",label:"Rounds",icon:"🔍"},{id:"tasks",label:"Tasks",icon:"📌"}];

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      {toast&&(
        <div style={{position:"fixed",top:70,left:"50%",transform:"translateX(-50%)",zIndex:9999,
          background:toast.ok?"#dcfce7":"#fee2e2",color:toast.ok?"#16a34a":"#e11d48",
          borderRadius:10,padding:"10px 20px",fontWeight:700,fontSize:13,
          boxShadow:"0 4px 16px rgba(0,0,0,.15)",whiteSpace:"nowrap"}}>
          {toast.msg}
        </div>
      )}

      {/* Sub-tab nav */}
      <div style={{background:C.white,borderRadius:14,padding:"12px 16px",border:`1px solid ${C.border}`,display:"flex",gap:8,flexWrap:"wrap"}}>
        {subTabs.map(t=>(
          <button key={t.id} onClick={()=>setSub(t.id)}
            style={{background:sub===t.id?C.primary:C.pale,color:sub===t.id?"white":C.primary,
              border:"none",borderRadius:9,padding:"8px 16px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {/* ── OVERVIEW ── */}
      {sub==="overview"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:12}}>
            {[
              {label:"Open",      val:issues.filter(i=>i.status==="open").length,       color:"#2563eb",bg:"#eff6ff",icon:"🔓"},
              {label:"In Progress",val:issues.filter(i=>i.status==="in_progress").length,color:"#d97706",bg:"#fffbeb",icon:"🔄"},
              {label:"Resolved",  val:issues.filter(i=>i.status==="resolved").length,   color:"#16a34a",bg:"#dcfce7",icon:"✅"},
              {label:"Critical ⚠️",val:issues.filter(i=>i.priority==="critical"&&i.status!=="resolved").length,color:"#e11d48",bg:"#fff0f3",icon:"🚨"},
            ].map(s=>(
              <div key={s.label} style={{background:s.bg,borderRadius:14,padding:"16px",textAlign:"center",border:`1px solid ${s.color}20`}}>
                <div style={{fontSize:22}}>{s.icon}</div>
                <div style={{fontSize:28,fontWeight:900,color:s.color,lineHeight:1.1}}>{s.val}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:4,fontWeight:600}}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Priority bar chart */}
          <div style={{background:C.white,borderRadius:14,padding:"20px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:14}}>🔧 Open Issues by Priority</div>
            {PRIS.map(p=>{
              const cnt=issues.filter(i=>i.priority===p.en&&i.status!=="resolved").length;
              const tot=issues.filter(i=>i.status!=="resolved").length;
              const pct=tot?Math.round(cnt/tot*100):0;
              return (
                <div key={p.en} style={{marginBottom:10}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:12,fontWeight:600,marginBottom:4}}>
                    <span style={{color:p.color,fontFamily:fmFont}}>{p.ur}</span>
                    <span style={{color:C.muted}}>{cnt} issues</span>
                  </div>
                  <div style={{height:8,background:"#f3f4f6",borderRadius:4,overflow:"hidden"}}>
                    <div style={{height:"100%",width:`${pct}%`,background:p.color,borderRadius:4,transition:"width .5s"}}/>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Recent */}
          <div style={{background:C.white,borderRadius:14,padding:"20px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:14}}>🕐 Recent Issues</div>
            {issues.slice(0,6).map(issue=>{
              const cat=CATS.find(c=>c.en===issue.category)||CATS[6];
              return (
                <div key={issue.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 0",borderBottom:"1px solid #f3f4f6"}}>
                  <span style={{fontSize:20,flexShrink:0}}>{cat.icon}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,fontSize:13,color:C.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{issue.title}</div>
                    <div style={{fontSize:11,color:C.muted}}>{LOCS.find(l=>l.en===issue.location)?.ur||issue.location} · {new Date(issue.reported_at).toLocaleDateString()}</div>
                  </div>
                  <PriTag v={issue.priority}/>
                  <StTag v={issue.status}/>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── ISSUES ── */}
      {sub==="issues"&&(
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div style={{background:C.white,borderRadius:12,padding:"14px 16px",border:`1px solid ${C.border}`,display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search issues..."
              style={{flex:1,minWidth:160,border:"1px solid #d1d5db",borderRadius:8,padding:"7px 12px",fontSize:13}}/>
            <select value={fStatus} onChange={e=>setFStatus(e.target.value)} style={{border:"1px solid #d1d5db",borderRadius:8,padding:"7px 12px",fontSize:13}}>
              <option value="all">All Status</option>
              <option value="open">Open</option>
              <option value="in_progress">In Progress</option>
              <option value="resolved">Resolved</option>
            </select>
            <select value={fPri} onChange={e=>setFPri(e.target.value)} style={{border:"1px solid #d1d5db",borderRadius:8,padding:"7px 12px",fontSize:13}}>
              <option value="all">All Priority</option>
              {PRIS.map(p=><option key={p.en} value={p.en}>{p.ur}</option>)}
            </select>
          </div>

          {filt.length===0&&<div style={{textAlign:"center",color:C.muted,padding:"40px",background:C.white,borderRadius:14}}>No issues found</div>}
          {filt.map(issue=>{
            const cat=CATS.find(c=>c.en===issue.category)||CATS[6];
            const pri=PRIS.find(p=>p.en===issue.priority)||PRIS[1];
            const editing=editNotes[issue.id]!==undefined;
            return (
              <div key={issue.id} style={{background:C.white,borderRadius:14,padding:"18px",border:`1px solid ${C.border}`,borderLeft:`4px solid ${pri.color}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,marginBottom:10}}>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:3}}>{cat.icon} {issue.title}</div>
                    <div style={{fontSize:12,color:C.muted}}>
                      {LOCS.find(l=>l.en===issue.location)?.ur||issue.location} · {cat.ur} · {new Date(issue.reported_at).toLocaleDateString()}
                    </div>
                    {issue.description&&<div style={{fontSize:12,color:C.muted,marginTop:4,fontStyle:"italic",direction:"rtl",fontFamily:fmFont}}>"{issue.description}"</div>}
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"flex-end"}}>
                    <PriTag v={issue.priority}/><StTag v={issue.status}/>
                    <div style={{display:"flex",gap:4,marginTop:4}}>
                      <button onClick={()=>setEditingIssue({id:issue.id,title:issue.title,description:issue.description||"",priority:issue.priority,location:issue.location,category:issue.category})}
                        style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:6,padding:"3px 8px",fontSize:11,color:"#1d4ed8",cursor:"pointer",fontWeight:600}}>✏️ Edit</button>
                      <button onClick={()=>setDelConfirm(issue.id)}
                        style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:6,padding:"3px 8px",fontSize:11,color:"#dc2626",cursor:"pointer",fontWeight:600}}>🗑️</button>
                    </div>
                  </div>
                </div>
                {delConfirm===issue.id&&(
                  <div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:8,display:"flex",gap:10,alignItems:"center"}}>
                    <span style={{fontSize:13,color:"#dc2626",flex:1}}>Delete this issue permanently?</span>
                    <button onClick={()=>deleteIssue(issue.id)} style={{background:"#dc2626",color:"white",border:"none",borderRadius:7,padding:"5px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>Yes, Delete</button>
                    <button onClick={()=>setDelConfirm(null)} style={{background:"#f3f4f6",border:"none",borderRadius:7,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                  </div>
                )}
                {editingIssue&&editingIssue.id===issue.id&&(
                  <div style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:10,padding:"14px",marginBottom:8,display:"flex",flexDirection:"column",gap:8}}>
                    <div style={{fontWeight:700,fontSize:13,color:C.primary,marginBottom:4}}>Edit Issue</div>
                    <input value={editingIssue.title} onChange={e=>setEditingIssue(p=>({...p,title:e.target.value}))} placeholder="Title"
                      style={{border:"1px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13,width:"100%"}}/>
                    <textarea value={editingIssue.description} onChange={e=>setEditingIssue(p=>({...p,description:e.target.value}))} placeholder="Description (optional)" rows={2}
                      style={{border:"1px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13,width:"100%",resize:"vertical"}}/>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                      <select value={editingIssue.priority} onChange={e=>setEditingIssue(p=>({...p,priority:e.target.value}))} style={{border:"1px solid #d1d5db",borderRadius:8,padding:"6px 10px",fontSize:12}}>
                        {PRIS.map(p=><option key={p.en} value={p.en}>{p.ur} ({p.en})</option>)}
                      </select>
                      <select value={editingIssue.location} onChange={e=>setEditingIssue(p=>({...p,location:e.target.value}))} style={{border:"1px solid #d1d5db",borderRadius:8,padding:"6px 10px",fontSize:12}}>
                        {LOCS.map(l=><option key={l.en} value={l.en}>{l.ur}</option>)}
                      </select>
                      <select value={editingIssue.category} onChange={e=>setEditingIssue(p=>({...p,category:e.target.value}))} style={{border:"1px solid #d1d5db",borderRadius:8,padding:"6px 10px",fontSize:12}}>
                        {CATS.map(c=><option key={c.en} value={c.en}>{c.icon} {c.ur}</option>)}
                      </select>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={saveEditIssue} style={{background:C.primary,color:"white",border:"none",borderRadius:8,padding:"6px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>Save Changes</button>
                      <button onClick={()=>setEditingIssue(null)} style={{background:"#f3f4f6",border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                    </div>
                  </div>
                )}

                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>
                  {["open","in_progress","resolved"].map(s=>(
                    <button key={s} onClick={()=>updateStatus(issue.id,s)} disabled={issue.status===s}
                      style={{padding:"5px 11px",borderRadius:7,border:`1px solid ${issue.status===s?C.primary:"#d1d5db"}`,
                        background:issue.status===s?C.pale:"white",color:issue.status===s?C.primary:C.muted,
                        fontSize:11,fontWeight:700,cursor:issue.status===s?"default":"pointer"}}>
                      {STATUS_META[s]?.ur}
                    </button>
                  ))}
                </div>

                {!editing&&(
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    {issue.admin_notes&&<div style={{flex:1,background:"#f0fdf7",borderRadius:8,padding:"6px 10px",fontSize:12,color:G,direction:"rtl",fontFamily:fmFont}}>💬 {issue.admin_notes}</div>}
                    <button onClick={()=>setEditNotes(p=>({...p,[issue.id]:issue.admin_notes||""}))}
                      style={{background:"#f3f4f6",border:"none",borderRadius:7,padding:"5px 10px",fontSize:11,cursor:"pointer",color:C.muted,whiteSpace:"nowrap"}}>
                      {issue.admin_notes?"Edit note":"Add note for FM"}
                    </button>
                  </div>
                )}
                {editing&&(
                  <div style={{display:"flex",gap:8,alignItems:"flex-start"}}>
                    <input value={editNotes[issue.id]} onChange={e=>setEditNotes(p=>({...p,[issue.id]:e.target.value}))}
                      placeholder="Note visible to facility manager in Urdu or English..."
                      style={{flex:1,border:"1.5px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13}}/>
                    <button onClick={()=>saveNote(issue.id)} disabled={savingNote[issue.id]}
                      style={{background:C.primary,color:"white",border:"none",borderRadius:8,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                      {savingNote[issue.id]?"...":"Save"}
                    </button>
                    <button onClick={()=>setEditNotes(p=>{const n={...p};delete n[issue.id];return n;})}
                      style={{background:"#f3f4f6",color:C.muted,border:"none",borderRadius:8,padding:"7px 10px",fontSize:12,cursor:"pointer"}}>✕</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── TEMPLATES ── */}
      {sub==="templates"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{background:C.white,borderRadius:14,padding:"18px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:12}}>➕ New Checklist Template</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <input value={newTplEn} onChange={e=>setNewTplEn(e.target.value)} placeholder="Title (English)"
                style={{border:"1px solid #d1d5db",borderRadius:8,padding:"8px 12px",fontSize:13}}/>
              <input value={newTplUr} onChange={e=>setNewTplUr(e.target.value)} placeholder="عنوان (اردو)" dir="rtl"
                style={{border:"1px solid #d1d5db",borderRadius:8,padding:"8px 12px",fontSize:13,fontFamily:fmFont}}/>
            </div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
              <button onClick={addTemplate} disabled={!newTplEn.trim()||savingTpl}
                style={{background:C.primary,color:"white",border:"none",borderRadius:9,padding:"9px 20px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                {savingTpl?"Saving...":"Create Template"}
              </button>
              <div style={{width:1,height:28,background:"#e5e7eb"}}/>
              <button onClick={seedDefaults} disabled={seedingDefaults}
                style={{background:seedingDefaults?"#9ca3af":"#7c3aed",color:"white",border:"none",borderRadius:9,padding:"9px 20px",fontWeight:700,fontSize:13,cursor:seedingDefaults?"not-allowed":"pointer",display:"flex",alignItems:"center",gap:7}}>
                {seedingDefaults?"⏳ Creating...":"📋 Load Default Checklists"}
              </button>
              <span style={{fontSize:11,color:C.muted}}>Adds 5 ready-made templates: Masjid, Classrooms, Electrical, Hygiene, Safety</span>
            </div>
          </div>

          {templates.length===0&&(
            <div style={{textAlign:"center",color:C.muted,padding:"30px",background:C.white,borderRadius:14}}>
              No templates yet. Create your first inspection checklist above.
            </div>
          )}
          {templates.map(tpl=>(
            <div key={tpl.id} style={{background:C.white,borderRadius:14,border:`1px solid ${C.border}`,overflow:"hidden"}}>
              <div style={{padding:"16px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10}}>
                <div>
                  <div style={{fontWeight:800,fontSize:15,color:C.text}}>{tpl.title}</div>
                  {tpl.title_ur&&<div style={{fontSize:13,color:C.muted,direction:"rtl",fontFamily:fmFont,marginTop:2}}>{tpl.title_ur}</div>}
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>toggleExpand(tpl.id)}
                    style={{background:C.pale,color:C.primary,border:"none",borderRadius:8,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                    {expanded===tpl.id?"▲ Hide":"▼ Items"}
                  </button>
                  <button onClick={()=>delTemplate(tpl.id)}
                    style={{background:"#fff0f3",color:"#e11d48",border:"none",borderRadius:8,padding:"7px 12px",fontSize:12,cursor:"pointer"}}>🗑️</button>
                </div>
              </div>

              {expanded===tpl.id&&(
                <div style={{borderTop:`1px solid ${C.border}`,padding:"14px 18px",background:"#f9fafb"}}>
                  {(tplItems[tpl.id]||[]).map((item,i)=>(
                    <div key={item.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:"1px solid #f3f4f6",gap:8}}>
                      <div style={{flex:1}}>
                        <span style={{fontSize:13,color:C.text,fontWeight:600}}>{i+1}. {item.label}</span>
                        {item.label_ur&&<span style={{fontSize:12,color:C.muted,marginRight:8,direction:"rtl",fontFamily:fmFont}}> — {item.label_ur}</span>}
                        {item.area&&<span style={{fontSize:11,background:"#f3f4f6",borderRadius:5,padding:"1px 7px",color:C.muted,marginRight:6}}>{item.area}</span>}
                      </div>
                      <button onClick={()=>delItem(tpl.id,item.id)}
                        style={{background:"#fff0f3",color:"#e11d48",border:"none",borderRadius:6,padding:"4px 9px",fontSize:11,cursor:"pointer"}}>✕</button>
                    </div>
                  ))}
                  <div style={{marginTop:12,display:"grid",gridTemplateColumns:"2fr 2fr 1fr auto",gap:8,alignItems:"center"}}>
                    <input value={newItemEn} onChange={e=>setNewItemEn(e.target.value)} placeholder="Item label (English)"
                      style={{border:"1px solid #d1d5db",borderRadius:7,padding:"7px 10px",fontSize:12}}/>
                    <input value={newItemUr} onChange={e=>setNewItemUr(e.target.value)} placeholder="اردو" dir="rtl"
                      style={{border:"1px solid #d1d5db",borderRadius:7,padding:"7px 10px",fontSize:12,fontFamily:fmFont}}/>
                    <input value={newItemArea} onChange={e=>setNewItemArea(e.target.value)} placeholder="Area"
                      style={{border:"1px solid #d1d5db",borderRadius:7,padding:"7px 10px",fontSize:12}}/>
                    <button onClick={()=>addItem(tpl.id)} disabled={!newItemEn.trim()||savingItem}
                      style={{background:C.primary,color:"white",border:"none",borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
                      {savingItem?"...":"+ Add"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ── ROUNDS ── */}
      {sub==="rounds"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* One-click weekly assignment */}
          <div style={{background:"linear-gradient(135deg,#1e1b4b,#4c1d95)",borderRadius:14,padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,flexWrap:"wrap"}}>
            <div>
              <div style={{fontWeight:800,fontSize:15,color:"white"}}>🗓️ Assign This Week's Rounds</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,.7)",marginTop:2}}>Creates one pending round per active template, due in 7 days</div>
            </div>
            <button onClick={assignWeeklyRounds} disabled={assigningWeekly||templates.filter(t=>t.is_active).length===0}
              style={{background:assigningWeekly?"rgba(255,255,255,.3)":"white",color:"#4c1d95",border:"none",
                borderRadius:10,padding:"10px 22px",fontWeight:800,fontSize:14,cursor:"pointer",flexShrink:0}}>
              {assigningWeekly?"Assigning...":"⚡ Assign All Now"}
            </button>
          </div>

          <div style={{background:C.white,borderRadius:14,padding:"18px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:12}}>📅 Assign Single Inspection Round</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr auto auto",gap:10,alignItems:"end"}}>
              <div>
                <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>CHECKLIST</label>
                <select value={newRndTpl} onChange={e=>setNewRndTpl(e.target.value)}
                  style={{width:"100%",border:"1px solid #d1d5db",borderRadius:8,padding:"8px 12px",fontSize:13}}>
                  <option value="">Select template...</option>
                  {templates.filter(t=>t.is_active).map(t=><option key={t.id} value={t.id}>{t.title}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:4}}>DUE DATE</label>
                <input type="date" value={newRndDue} onChange={e=>setNewRndDue(e.target.value)}
                  style={{border:"1px solid #d1d5db",borderRadius:8,padding:"8px 12px",fontSize:13}}/>
              </div>
              <button onClick={createRound} disabled={!newRndTpl||savingRnd}
                style={{background:newRndTpl?C.primary:"#d1d5db",color:"white",border:"none",borderRadius:9,padding:"9px 20px",fontWeight:700,fontSize:13,cursor:newRndTpl?"pointer":"not-allowed"}}>
                {savingRnd?"Assigning...":"Assign"}
              </button>
            </div>
          </div>

          {rounds.length===0&&<div style={{textAlign:"center",color:C.muted,padding:"30px",background:C.white,borderRadius:14}}>No inspection rounds yet.</div>}
          {rounds.map(round=>{
            const done=round.status==="completed";
            return (
              <div key={round.id} style={{background:C.white,borderRadius:14,padding:"16px 18px",border:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:800,fontSize:14,color:C.text}}>{round.inspection_templates?.title||round.template_title||"Inspection"}</div>
                  {round.inspection_templates?.title_ur&&<div style={{fontSize:12,color:C.muted,direction:"rtl",fontFamily:fmFont}}>{round.inspection_templates.title_ur}</div>}
                  <div style={{fontSize:12,color:C.muted,marginTop:3}}>
                    Created: {new Date(round.created_at).toLocaleDateString()}
                    {round.due_date&&" · Due: "+new Date(round.due_date).toLocaleDateString()}
                    {round.completed_at&&" · Done: "+new Date(round.completed_at).toLocaleDateString()}
                  </div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{background:done?"#dcfce7":"#fffbeb",color:done?"#16a34a":"#d97706",borderRadius:8,padding:"4px 12px",fontWeight:700,fontSize:12}}>
                    {done?"✅ Done":"⏳ Pending"}
                  </span>
                  {done&&(
                    <button onClick={()=>openRoundDetails(round)}
                      style={{background:C.pale,color:C.primary,border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                      View
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── TASKS ── */}
      {sub==="tasks"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* Create task form */}
          <div style={{background:C.white,borderRadius:14,padding:"20px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:14}}>📌 Assign Task to Facility Manager</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <input value={newTask.title} onChange={e=>setNewTask(p=>({...p,title:e.target.value}))}
                placeholder="Task title (required)" maxLength={120}
                style={{border:"1.5px solid #d1d5db",borderRadius:9,padding:"9px 13px",fontSize:14,fontWeight:600}}/>
              <textarea value={newTask.description} onChange={e=>setNewTask(p=>({...p,description:e.target.value}))}
                placeholder="Detailed description — what needs to be done? (required)" rows={3}
                style={{border:"1.5px solid #d1d5db",borderRadius:9,padding:"9px 13px",fontSize:13,resize:"vertical"}}/>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:10}}>
                <div>
                  <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:3}}>DEADLINE *</label>
                  <input type="date" value={newTask.deadline} onChange={e=>setNewTask(p=>({...p,deadline:e.target.value}))}
                    style={{width:"100%",border:"1.5px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13}}/>
                </div>
                <div>
                  <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:3}}>PRIORITY</label>
                  <select value={newTask.priority} onChange={e=>setNewTask(p=>({...p,priority:e.target.value}))}
                    style={{width:"100%",border:"1px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13}}>
                    {PRIS.map(p=><option key={p.en} value={p.en}>{p.ur} ({p.en})</option>)}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:3}}>LOCATION</label>
                  <select value={newTask.location} onChange={e=>setNewTask(p=>({...p,location:e.target.value}))}
                    style={{width:"100%",border:"1px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13}}>
                    {LOCS.map(l=><option key={l.en} value={l.en}>{l.ur}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:11,fontWeight:700,color:C.muted,display:"block",marginBottom:3}}>CATEGORY</label>
                  <select value={newTask.category} onChange={e=>setNewTask(p=>({...p,category:e.target.value}))}
                    style={{width:"100%",border:"1px solid #d1d5db",borderRadius:8,padding:"7px 10px",fontSize:13}}>
                    {CATS.map(c=><option key={c.en} value={c.en}>{c.icon} {c.ur}</option>)}
                  </select>
                </div>
              </div>
              <button onClick={createTask} disabled={savingTask||!newTask.title.trim()||!newTask.description.trim()||!newTask.deadline}
                style={{background:newTask.title.trim()&&newTask.description.trim()&&newTask.deadline?C.primary:"#d1d5db",
                  color:"white",border:"none",borderRadius:10,padding:"10px 24px",fontWeight:800,fontSize:14,cursor:"pointer",alignSelf:"flex-start"}}>
                {savingTask?"Saving...":"📌 Assign Task"}
              </button>
            </div>
          </div>

          {/* Active tasks list */}
          <div style={{background:C.white,borderRadius:14,padding:"18px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:800,fontSize:15,color:C.text,marginBottom:12}}>Active Tasks ({adminTasks.length})</div>
            {adminTasks.length===0&&<div style={{textAlign:"center",color:C.muted,padding:"20px"}}>No active tasks assigned.</div>}
            {adminTasks.map(task=>{
              const pri=PRIS.find(p=>p.en===task.priority)||PRIS[1];
              const dl=task.deadline?Math.ceil((new Date(task.deadline)-new Date())/(1000*60*60*24)):null;
              const overdue=dl!==null&&dl<0;
              const st=STATUS_META[task.status]||STATUS_META.open;
              return (
                <div key={task.id} style={{padding:"14px",borderRadius:10,marginBottom:10,
                  border:`1.5px solid ${overdue?"#fca5a5":"#e5e7eb"}`,background:overdue?"#fef2f2":"#f9fafb"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,marginBottom:6}}>
                    <div style={{fontWeight:700,fontSize:14,color:C.text,flex:1}}>{task.title}</div>
                    <div style={{display:"flex",gap:6,flexShrink:0}}>
                      <span style={{background:pri.bg,color:pri.color,borderRadius:6,padding:"2px 8px",fontSize:11,fontWeight:700}}>{pri.ur}</span>
                      <span style={{background:st.bg,color:st.color,borderRadius:6,padding:"2px 8px",fontSize:11,fontWeight:700}}>{st.ur}</span>
                    </div>
                  </div>
                  {task.description&&<div style={{fontSize:12,color:C.muted,marginBottom:6,fontStyle:"italic"}}>"{task.description}"</div>}
                  {dl!==null&&(
                    <div style={{fontSize:12,color:overdue?"#dc2626":dl<=3?"#d97706":"#6b7280",fontWeight:700}}>
                      📅 Deadline: {new Date(task.deadline).toLocaleDateString()} &nbsp;—&nbsp;
                      {overdue?`${Math.abs(dl)} days overdue ⚠️`:dl===0?"Due today!":dl===1?"Due tomorrow":`${dl} days left`}
                    </div>
                  )}
                  <div style={{display:"flex",gap:8,marginTop:8}}>
                    {["open","in_progress","resolved"].map(s=>(
                      <button key={s} onClick={async()=>{
                        const upd={status:s,...(s==="resolved"?{resolved_at:new Date().toISOString()}:{})};
                        await supabase.from("facility_issues").update(upd).eq("id",task.id);
                        load();
                      }} disabled={task.status===s}
                        style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${task.status===s?C.primary:"#d1d5db"}`,
                          background:task.status===s?C.pale:"white",color:task.status===s?C.primary:C.muted,
                          fontSize:11,fontWeight:700,cursor:task.status===s?"default":"pointer"}}>
                        {STATUS_META[s]?.ur}
                      </button>
                    ))}
                    <button onClick={async()=>{
                      if(!window.confirm("Delete this task?")) return;
                      await supabase.from("facility_issues").delete().eq("id",task.id);
                      load();
                    }} style={{marginLeft:"auto",background:"#fff0f3",color:"#e11d48",border:"none",borderRadius:6,padding:"4px 10px",fontSize:11,cursor:"pointer"}}>🗑️</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Round results modal */}
      {viewRound&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9999,
          display:"flex",alignItems:"center",justifyContent:"center",padding:16}}
          onClick={()=>setViewRound(null)}>
          <div style={{background:"white",borderRadius:16,maxWidth:560,width:"100%",
            maxHeight:"80vh",overflowY:"auto",padding:24,boxShadow:"0 24px 60px rgba(0,0,0,.3)"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div style={{fontWeight:800,fontSize:16,color:C.text}}>
                🔍 {viewRound.inspection_templates?.title||"Inspection"} — Results
              </div>
              <button onClick={()=>setViewRound(null)} style={{background:"#f3f4f6",border:"none",borderRadius:8,width:32,height:32,fontSize:16,cursor:"pointer"}}>×</button>
            </div>
            {rndResponses.length===0&&<div style={{textAlign:"center",color:C.muted,padding:20}}>No responses found.</div>}
            {rndResponses.map((r,i)=>{
              const col=r.result==="ok"?"#16a34a":r.result==="attention"?"#d97706":"#e11d48";
              const bg =r.result==="ok"?"#dcfce7":r.result==="attention"?"#fffbeb":"#fff0f3";
              return (
                <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"10px 0",borderBottom:"1px solid #f3f4f6",gap:10}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.text}}>{i+1}. {r.item_label}</div>
                    {r.notes&&<div style={{fontSize:12,color:C.muted,marginTop:2,direction:"rtl",fontFamily:fmFont}}>{r.notes}</div>}
                  </div>
                  <span style={{background:bg,color:col,borderRadius:7,padding:"3px 10px",fontSize:11,fontWeight:700,flexShrink:0,fontFamily:fmFont}}>
                    {r.result==="ok"?UR.inspOk:r.result==="attention"?UR.inspAtt:UR.inspCrit}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
